<template>
  <page :manualInit="listState.init" :manualErr="listState.initErr" @reload="doInit">
    <template slot="pageAction">
      <div class="actionBlock" v-if="showStatusBtn">
        <v-tooltip bottom>
          <v-btn flat color="secondary" @click="lifeCycle = !lifeCycle" slot="activator">
            Status Overview
            <v-icon right>mdi-file-document-box</v-icon>
          </v-btn>
          <span>Status Overview</span>
        </v-tooltip>
      </div>
    </template>
    <div v-if="renderAppType">
      <v-subheader>
        {{labels.appID}}
      </v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorQuote', 'motorQuoteQuery'])">
            <v-card :class="isMatchRoute('motorQuoteListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'motorQuoteListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelQuote', 'travelQuoteQuery'])">
            <v-card :class="isMatchRoute('travelQuoteListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelQuoteListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireQuote', 'fireQuoteQuery'])">
            <v-card :class="isMatchRoute('fireQuoteListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireQuoteListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['paQuote', 'paQuoteQuery'])">
            <v-card :class="isMatchRoute('paQuoteListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'paQuoteListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoQuote', 'cargoQuoteQuery'])">
            <v-card :class="isMatchRoute('cargoQuoteListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'cargoQuoteListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidQuote', 'maidQuoteQuery'])">
            <v-card :class="isMatchRoute('maidQuoteListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidQuoteListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packageQuote', 'packageQuoteQuery'])">
            <v-card :class="isMatchRoute('packageQuoteListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'packageQuoteListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
    <v-navigation-drawer temporary fixed clipped right app v-model="lifeCycle" width="400">
      <life-cycle query></life-cycle>
    </v-navigation-drawer>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'
import LifeCycle from './LifeCycle'
import { appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        appID: 'Application Type'
      },
      lifeCycle: false
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'quoteListing') {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listState() {
      return this.$store.state.agency.listing
    },
    renderAppType() {
      if (this.isMatchRouteExact('quoteListing')) {
        return true
      } else {
        return false
      }
    },
    showStatusBtn() {
      // We only want to show at query page
      if (this.isMatchRouteExact('quoteListing') ||
        this.isMatchRouteExact('motorQuoteListing') ||
        this.isMatchRouteExact('fireQuoteListing') ||
        this.isMatchRouteExact('cargoQuoteListing') ||
        this.isMatchRouteExact('travelQuoteListing') ||
        this.isMatchRouteExact('paQuoteListing') ||
        this.isMatchRouteExact('maidQuoteListing') ||
        this.isMatchRouteExact('packageQuoteListing')) {
        return false
      } else {
        return true
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('agencyQuoteListInit')
      this.$store.dispatch('quoteSettingsInit')
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ],
  components: {
    LifeCycle
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";
</style>
